import user_api from '@/api/user';
import { request_list} from '@/commons/hpod';
import configs from "@/configs";
import Vue from 'vue';

const state = {
    token: '',
    user: {},
    role: {},
    resData: {},
    twoFactor: {
        enabled: false,
        qrCode: '',
        secret: '',
        loading: false
    }
};

const getters = {};

const actions = {
    login({ commit, dispatch }, loginInfo) {   
        user_api.login(data => {
            commit('setToken', data);
            dispatch("roles/getList", null, {root:true} );
            dispatch("commons/getExpiredContactCare", null, { root: true });
        }, Vue.http, loginInfo);
    },
    logout({ commit, dispatch }, loginInfo) {   
        user_api.logout(data => {
            commit('setExpiredContactCare', null);
        }, Vue.http, loginInfo, this.state.authentication.token);
    },
    me({ commit }) {
        request_list('me', ret => {
            commit('setUser', ret.data);
        }, Vue.http, {}, this.state.authentication.token);
    },
    async check2FAStatus({ commit, state }) {
        try {
            const response = await Vue.http.get(`${configs.API}/admin/api/2fa/status/`, {
                headers: {
                    'Authorization': `Bearer ${state.token}`
                }
            });
            if (response.body.status === 200 || response.body.status === 'success') {
                commit('set2FAEnabled', response.body.data.enabled);
            }
            return response.body;
        } catch (error) {
            console.error('Check 2FA status error:', error);
            throw error;
        }
    },
    async enable2FA({ commit, state }) {
        commit('set2FALoading', true);
        try {
            const response = await Vue.http.post(`${configs.API}/admin/api/2fa/enable/`, {}, {
                headers: {
                    'Authorization': `Bearer ${state.token}`
                }
            });
            console.log('Enable 2FA response:', response.body);
            if (response.body.status === 200 || response.body.status === 'success') {
                console.log('Response data:', response.body.data);
                commit('set2FAQRCode', {
                    qrCode: response.body.data.qr_code,
                    secret: response.body.data.secret
                });
            }
            return response.body;
        } catch (error) {
            console.error('Enable 2FA error:', error);
            return { status: 'error', message: error.message || 'Lỗi kết nối server' };
        } finally {
            commit('set2FALoading', false);
        }
    },
    async verify2FACode({ commit, state }, otpCode) {
        commit('set2FALoading', true);
        try {
            const response = await Vue.http.post(`${configs.API}/admin/api/2fa/verify-enable/`, { otp_code: otpCode }, {
                headers: {
                    'Authorization': `Bearer ${state.token}`
                }
            });
            if (response.body.status === 200 || response.body.status === 'success') {
                commit('set2FAEnabled', true);
            }
            return response.body;
        } catch (error) {
            console.error('Verify 2FA error:', error);
            throw error;
        } finally {
            commit('set2FALoading', false);
        }
    },
    async disable2FA({ commit, state }, otpCode) {
        commit('set2FALoading', true);
        try {
            const response = await Vue.http.post(`${configs.API}/admin/api/2fa/disable/`, { otp_code: otpCode }, {
                headers: {
                    'Authorization': `Bearer ${state.token}`
                }
            });
            if (response.body.status === 200 || response.body.status === 'success') {
                commit('set2FAEnabled', false);
                commit('clear2FAData');
            }
            return response.body;
        } catch (error) {
            console.error('Disable 2FA error:', error);
            throw error;
        } finally {
            commit('set2FALoading', false);
        }
    }
    
};

const mutations = {
    setToken(state, data) {
        state.resData = data;
        if(data.status_code == 400){
            return;
        }

        state.token = data.token;
        state.user = data.user;
        localStorage.setItem('jwt', data.token);
        localStorage.setItem('user', JSON.stringify(data.user));  
    },
    setRole(state, data) {
        state.role = data;
    },
    setUser(state, data) {
        state.user = data;
    },
    set2FAEnabled(state, enabled) {
        state.twoFactor.enabled = enabled;
    },
    set2FALoading(state, loading) {
        state.twoFactor.loading = loading;
    },
    set2FAQRCode(state, { qrCode, secret }) {
        state.twoFactor.qrCode = qrCode;
        state.twoFactor.secret = secret;
    },
    clear2FAData(state) {
        state.twoFactor.qrCode = '';
        state.twoFactor.secret = '';
    }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
